'use client';

import React, { useState } from 'react';

import { toast } from 'sonner';

const poll = {
  id: 'poll-001',
  question: 'Best drop of 2025 so far?',
  options: [
    { id: 'opt-a', label: 'Chrome Pulse', votes: 1240 },
    { id: 'opt-b', label: 'Neon Drift', votes: 980 },
    { id: 'opt-c', label: 'Bass Theory', votes: 860 },
  ],
  totalVotes: 3080,
};

export default function PulsePollWidget() {
  const [voted, setVoted] = useState<string | null>(null);

  const handleVote = (optId: string) => {
    if (voted) return;
    setVoted(optId);
    toast.success('Your PULSE vote has been recorded!');
  };

  const total = poll.totalVotes + (voted ? 1 : 0);

  return (
    <div className="glass-card rounded-xl p-4">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-2 h-2 rounded-full pulse-dot" style={{ background: 'var(--primary)' }} />
        <p className="text-xs font-semibold" style={{ color: 'var(--primary)' }}>PULSE Poll · Active</p>
      </div>
      <p className="text-sm font-semibold mb-4">{poll.question}</p>
      <div className="space-y-2.5">
        {poll.options.map((opt) => {
          const votes = opt.votes + (voted === opt.id ? 1 : 0);
          const pct = Math.round((votes / total) * 100);
          const isVoted = voted === opt.id;
          return (
            <button
              key={opt.id}
              onClick={() => handleVote(opt.id)}
              disabled={!!voted}
              className="w-full text-left relative rounded-lg overflow-hidden transition-all duration-200"
              style={{
                border: `1px solid ${isVoted ? 'var(--primary)' : 'var(--border)'}`,
                background: 'var(--muted)',
                opacity: voted && !isVoted ? 0.7 : 1,
              }}
            >
              {voted && (
                <div className="absolute inset-0 rounded-lg transition-all duration-500"
                  style={{ width: `${pct}%`, background: isVoted ? 'rgba(168,85,247,0.2)' : 'rgba(42,42,64,0.5)' }} />
              )}
              <div className="relative flex items-center justify-between px-3 py-2.5">
                <span className="text-xs font-medium">{opt.label}</span>
                {voted && (
                  <span className="text-xs font-bold tabular-nums" style={{ color: isVoted ? 'var(--primary)' : 'var(--muted-foreground)' }}>
                    {pct}%
                  </span>
                )}
              </div>
            </button>
          );
        })}
      </div>
      <p className="text-xs mt-3 text-center tabular-nums" style={{ color: 'var(--muted-foreground)' }}>
        {total.toLocaleString()} votes cast
      </p>
    </div>
  );
}